import { render } from "./AncestorChromosomePainting.vue?vue&type=template&id=db475894&scoped=true"
import script from "./AncestorChromosomePainting.vue?vue&type=script&lang=js"
export * from "./AncestorChromosomePainting.vue?vue&type=script&lang=js"

import "./AncestorChromosomePainting.vue?vue&type=style&index=0&id=db475894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db475894"]])

export default __exports__